import { useState, useEffect } from "react";
import axios from "axios";
import "./styles/LEDScreen.css";
import Clock from "../../components/Clock";
import search from "/assets/icon/Search.svg";
import filter from "/assets/icon/Filter.svg";
import eye from "/assets/Eye.png";
import UserStatus from "../../components/UserStatus";
import Detail from '../../components/Detail';

const LEDScreen = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeDetail, setActiveDetail] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleDetailClick = (row) => {
    setActiveDetail(row);
  };

  const handleCloseDetail = () => {
    setActiveDetail(null);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const branchName =
        sessionStorage.getItem("selectedBranch") || "defaultBranchName";
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/led/${branchName}`
        );
        setData(response.data);
        setLoading(false);
      } catch (error) {
        console.error(
          `เกิดข้อผิดพลาด: ${
            error.response ? error.response.status : error.message
          }`
        );
      }
    };

    fetchData();
  }, []);

  const filteredData = data.filter((row) =>
    row.name.includes(searchTerm) ||
    row.code.includes(searchTerm) ||
    row.location.includes(searchTerm)
  );

  return (
    <div className="containerPage">
      <div className="sections1">
        <h1>จอ LED</h1>
        <h2>
          <Clock />
        </h2>
      </div>
      <div className="sectionsCctv">
        <div className="led-section">
          <div className="search-bar">
            <img src={search} alt="search" className="search-user" />
            <input
              type="text"
              placeholder="ค้นหาชื่อ, หมายเลขโทรศัพท์, หรืออีเมล"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <div>
              <img src={filter} alt="filter" className="filter-user" />
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>รหัสเสา</th>
                <th>ชื่อเสา</th>
                <th>สถานที่ติดตั้ง</th>
                <th>พิกัด</th>
                <th>สถานะเปิดปิด</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7">Loading...</td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((row, index) => (
                  <tr key={row.id || index}>
                    <td>{index + 1}</td>
                    <td>{row.code}</td>
                    <td>{row.name}</td>
                    <td>{row.location}</td>
                    <td>
                      {row.latitude}, {row.longitude}
                    </td>
                    <td>
                      <UserStatus isOnline={row.active} />
                    </td>
                    <td>
                      <img
                        style={{ cursor: "pointer" }}
                        src={eye}
                        alt="View Details"
                        onClick={() => handleDetailClick(row)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">ไม่พบข้อมูลที่ตรงกับการค้นหา</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {activeDetail && (
          <Detail
            title="จอ LED"
            onClose={handleCloseDetail}
            code={activeDetail.code}
            name={activeDetail.name}
            location={activeDetail.location}
            lat={activeDetail.latitude}
            lng={activeDetail.longitude}
            sensors={activeDetail.sensor}
            isMaster={activeDetail.isMaster}
            screenCode={activeDetail.screenId}
            screenModel={activeDetail.screenModel}
            installDate={activeDetail.screenInstallationDate}
            active={activeDetail.active}
            hasScreen={activeDetail.hasScreen}
          />
        )}
      </div>
    </div>
  );
};

export default LEDScreen;

